"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function Play(props) {
    return (React.createElement("svg", __assign({ height: "1em", preserveAspectRatio: "xMidYMid", viewBox: "0 0 128 128", width: "1em" }, props),
        React.createElement("path", { d: "M119.351 64L8.65 0v128z", fill: "currentColor" })));
}
exports.default = Play;
//# sourceMappingURL=Play.js.map